import React, { Component, createRef } from 'react';
import { Typography, Popconfirm, Tooltip } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { showNumber } from '../statusConfig';
import { amountToString } from '../../../util/tool';
import { statusToButtonsConfirmed } from '../statusConfig';
import RenderPopover from '../../../components/RenderPopover';
import './renderlist.less';

export default class RenderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleConfig: [
        {
          "name": "商品",
          "rolWidth": 1
        },
        {
          "name": "价格(元）",
          "rolWidth": 1
        },
        {
          "name": "税率",
          "rolWidth": 1
        },
        {
          "name": "商品价格(含税)",
          "rolWidth": 1
        },
        {
          "name": "数量",
          "rolWidth": 1
        },
        {
          "name": "总金额(元）",
          "rolWidth": 1
        },
        {
          "name": "订单状态",
          "rolWidth": 1
        },
        {
          "name": "交易操作",
          "rolWidth": 1
        }
      ]
    };
    this.receiveModalRef = createRef();
  }

  renderDetail = (info) => {
    if (!info) return;
    const parseInfo = JSON.parse((info));
    const surcharge_desc = !info ? [] : parseInfo;
    const record = { qoute: { surcharge_desc } };
    return <RenderPopover record={record} />;
  }


  render() {
    const { titleConfig = [] } = this.state;
    const { formateList = [], changeStatus = () => { }, toOrderDetail, perfectInformation, expandFn, onHandlerSpot, toProductDetail, toUserBill = () => { }, orderPurchaseAgain = () => { }, cancelOrder = () => { }, setCurrentItem = () => { } } = this.props;
    return (
      <div className='render-list-container'>
        <div className='render-list-title'>{titleConfig.map((item, index) => <div className={index < titleConfig.length - 3 ? (index > 0 ? 'render-list-title-item-normal1' : 'render-list-title-item') : 'render-list-title-item-normal'} key={index}>{item.name}</div>)}</div>

        <div className='render-list-content'>
          {
            formateList.map(item => {
              const buttonsConfirmedStatus = item.receiveInfo?.length ? 100 : 0;
              const reportStatus = item.port_quality_report.length === 0 && item.warehouse_quality_report.length === 0 ? 0 : 1;
              return (
                <div className='render-list-content-container' key={item.orderId}>
                  <div className='render-list-content-title'>
                    <div>订单号：{item.orderNo}</div>
                    <div>下单时间：{item.createTime}</div>
                    <div>
                      <span className='service pointer' onClick={() => onHandlerSpot(item)}></span>
                      <Tooltip title={item.supplier}>{item?.supplier?.length > 10 ? item?.supplier?.slice(0, 10) + '...' : item?.supplier} </Tooltip>
                    </div>
                    <div>期望到货日期：{item.expectedDate}</div>
                  </div>
                  <div className='render-list-content-products-container'>
                    <div className='render-list-content-products-container-left'>
                      {item.saleList.slice(0, item.isExpand ? showNumber : item.saleList.length).map((subItem, subIndex) => (
                        <div className='render-list-content-products-item' key={subIndex}>
                          <div className='render-list-content-detail'>
                            <div className='render-list-content-detail-product'>
                              <div className='render-list-content-detail-product-left'><img src={subItem.product_img} alt="" /></div>
                              <div className='render-list-content-detail-product-right'>
                                <div className='pointer render-list-content-detail-product-right-title' onClick={() => toProductDetail(subItem)}>{subItem.sku_name}</div>
                                <div>规格：{subItem.sale_norms}</div>
                              </div>
                            </div>
                            <div className='render-list-content-detail-item'>¥ {`${subItem.sale_price} / ${subItem.sale_unit}`}</div>
                            <div className='render-list-content-detail-item'>{subItem.tax_rate >= 0 ? (+subItem.tax_rate + '%') : '-'}</div>
                            <div className='render-list-content-detail-item'>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>{subItem.tax_inclusive_price === '-' ? '' : <>￥{amountToString(subItem.tax_inclusive_price)}</>} {this.renderDetail(subItem.surcharge_desc)}</div>                            </div>
                            <div className='render-list-content-detail-item'>{(+subItem.sale_number) + ' ' + subItem.sale_unit}</div>
                          </div>
                        </div>
                      ))}

                      {item.saleList.length > showNumber ?
                        <div className='render-list-content-expand pointer' onClick={() => expandFn(item)}>
                          {item.isExpand ? <span><span>共<Typography.Link>{item.saleList.length}</Typography.Link>种商品，查看全部</span><DownOutlined /></span> : <span><span>收起</span><UpOutlined /></span>}
                        </div> : null}
                    </div>
                    <div className='render-list-content-products-container-right'>
                      <div className='render-list-content-products-container-right-item'>¥ {amountToString(item.tax_inclusive_real_price)}</div>
                      <div className='render-list-content-products-container-right-item'>
                        <div><Typography.Link>{item.statusText}</Typography.Link></div>
                        <div className='pointer' onClick={() => { toOrderDetail(item); }}>订单详情</div>
                        {/* {((item.deliveryType === '3' || item.deliveryType === 3) && (item.orderStatus === 30 || item.orderStatus === 40)) ? <div className='pointer' style={{ marginTop: 8 }}><span onClick={() => { handleLogistics(item); }}>查看物流</span></div> : null} */}
                      </div>
                      <div className='render-list-content-products-container-right-item'>
                        {[50, 40].includes(+item.orderStatus) ? <Typography.Link onClick={() => orderPurchaseAgain(item)}>再来一单</Typography.Link> : null}
                        <div className='pointer' style={{ color: (item.orderStatus === 30 ? '#007AFF' : '#000') }}>
                          {/* <Popconfirm title='确定取消订单' onConfirm={() => { btnClicked(item); }}><Typography.Link>{item.buttonText}</Typography.Link></Popconfirm> */}
                          <Typography.Link onClick={() => cancelOrder(item)}>{item.buttonText}</Typography.Link>
                          {/* 部分收货 */}
                          {(item.orderStatus === 30 && buttonsConfirmedStatus) ? <Popconfirm title={`确定${item.orderStatus === 20 ? '取消' : `${item.receiveInfo.length ? '完结订单' : '收货'}`}?`} onConfirm={() => { changeStatus(item); }}><Typography.Link>{statusToButtonsConfirmed[buttonsConfirmedStatus]}</Typography.Link></Popconfirm> : null}
                          {/* 全部收货 */}
                          {(item.orderStatus === 30 && !buttonsConfirmedStatus) ? <Typography.Link onClick={() => setCurrentItem(item)}>{statusToButtonsConfirmed[buttonsConfirmedStatus]}</Typography.Link> : null}
                          {item.isInformation === 0 ? <div onClick={() => perfectInformation(item)}><Typography.Link>完善收货信息</Typography.Link></div> : null}
                        </div>
                        {reportStatus ? <Typography.Link onClick={() => { toOrderDetail(item, 1); }}>查看质检报告</Typography.Link> : ''}
                        {item.reconciliationInfo ? <Typography.Link onClick={() => { toUserBill(item); }}>查看对账单</Typography.Link> : ''}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}
